export function strings(site) {
  return Object.assign({
    global_privacy: 'Privacy',
    global_accessibility: 'Accessibility',
    global_feedback: 'Feedback',
    global_terms: 'Terms',
    dr_monthlyPayment: 'Monthly Payment',
    dr_tradeInValue: 'Trade-in Value',
    dr_creditRange: 'Credit Range',
    dr_cashDown: 'Cash Down',
    dr_loanTerms: 'Loan Term',
    dr_leaseTerms: 'Lease Term',
    dr_estPricingSummary: "Estimated Pricing Summary",
    vdp_estimateOnPrice: 'Estimated',
    vdp_salePrice: 'Sale Price'
  }, site.labels || {})
}